import { Mail, Phone, MapPin } from "lucide-react";
import { Link } from "react-router-dom";
import { useLanguage } from "@/context/LanguageContext";
import { navLinks } from "@/lib/nav";

export default function Footer() {
  const { t } = useLanguage();
  const year = new Date().getFullYear();
  const links = navLinks(t);
  links.splice(1, 0, { to: "/#company", label: t.nav.company, id: "company" });

  return (
    <footer data-testid="site-footer" className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 pt-14 sm:pt-20 pb-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-6">
            <p className="font-display font-bold text-lg" data-testid="footer-company-name">{t.nav.brandSub}</p>
            <nav className="mt-6 flex items-center gap-3" aria-label="Legal">
              <Link to="/terms" data-testid="footer-terms-link" className="text-sm text-slate-300 hover:text-lime-400 transition-colors">{t.footer.terms}</Link>
              <span className="w-px h-3.5 bg-white/20" aria-hidden="true" />
              <Link to="/privacy" data-testid="footer-privacy-link" className="text-sm text-slate-300 hover:text-lime-400 transition-colors">{t.footer.privacy}</Link>
            </nav>
          </div>
          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-widest text-slate-500">{t.footer.navTitle}</h4>
            <nav className="mt-4 flex flex-col gap-2.5">
              {links.map((l) => (
                <Link key={l.id} to={l.to} data-testid={`footer-nav-${l.id}-link`} className="text-sm text-slate-300 hover:text-lime-400 transition-colors w-fit">
                  {l.label}
                </Link>
              ))}
            </nav>
          </div>
          <div className="md:col-span-3">
            <h4 className="text-xs font-bold uppercase tracking-widest text-slate-500">{t.nav.contact}</h4>
            <div className="mt-4 flex flex-col gap-2.5 items-start">
              <a href="mailto:info@powerof-freedom.com" data-testid="footer-email-link" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-lime-400 transition-colors" dir="ltr">
                <Mail size={14} />
                info@powerof-freedom.com
              </a>
              <a href="tel:+962791337036" data-testid="footer-phone-link" className="inline-flex items-center gap-2 text-sm text-slate-300 hover:text-lime-400 transition-colors" dir="ltr">
                <Phone size={14} />
                +962 79 133 7036
              </a>
              <span data-testid="footer-address" className="inline-flex items-center gap-2 text-sm text-slate-300">
                <MapPin size={14} />
                {t.footer.address}
              </span>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-6 border-t border-white/10 text-center">
          <p className="text-sm text-slate-400">© {year} {t.footer.rights}</p>
        </div>
      </div>
    </footer>
  );
}
